import { render, staticRenderFns } from "./HumanCapitalAwardEndorse.vue?vue&type=template&id=220e6eea&v-if=isLoggedIn&"
import script from "./HumanCapitalAwardEndorse.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalAwardEndorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports